export default "__VITE_ASSET__BHKQm5Aa__"